/**
 * Internal API methods for the versioning workflow.
 * These endpoints are hidden from Swagger and should only be used
 * within the controlled versioning workflow for regulatory compliance.
 */
import { APPSERVER_API_PREFIX } from '@/main/app.constants';
import { getAxiosInstance } from '@/requests/axios.utilities';
import type { AxiosPromise } from 'axios';
import type { SeeqAxiosRequestConfig } from '@/requests/axios.utilities';

export class InternalVersioningApi {
  /**
   * Internal endpoint for renaming locked items during versioning.
   * This is NOT exposed in Swagger and should ONLY be called as part of
   * the lock-and-version workflow.
   */
  public renameForVersioning(
    body: {
      itemId: string;
      newName: string;
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig,
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: `${APPSERVER_API_PREFIX}/audit/version/rename-for-versioning`,
      data: body,
      ...extraHttpRequestConfig,
    }) as AxiosPromise<void>;
  }
}

export const internalVersioningApi = new InternalVersioningApi();
